module.exports = __webpack_public_path__ + "f15531860cf99f1300958f7c4ac2bb55.mp3";